// src/client/logger/logger.ts
//
// API-kompatibler Frontend-Logger-Wrapper.
//
// Hintergrund: Der Server-Logger unter `src/logging/logger.ts` zieht Node-Module
// (pino, pino-multi-stream, fs, path, async_hooks) und ist im Browser-Bundle nicht
// nutzbar. Damit Container-Code dennoch eine einheitliche Logging-API hat
// (`logger.info/warn/error("msg", {category, data})`), bietet dieses Modul die
// gleiche Signatur und delegiert intern an die `console`.
//
// Mittelfristig kann der Wrapper transparent auf eine "echte" Frontend-Logging-
// Pipeline umgestellt werden (z.B. Sentry-Breadcrumb, GraphQL-Logger-Mutation,
// Datadog Browser RUM) — Aufrufer im Container-Code muessen sich nicht aendern.

import {LogCategory} from "../../logging/types";
import {recordError} from "../helpers/reportContext";

export type FrontendLogOptions = {
    category: LogCategory;
    data?: unknown;
    error?: unknown;
};

const formatPayload = (options: FrontendLogOptions) => ({
    category: options.category,
    data: options.data,
    error: options.error,
});

export const logger = {
    info: (message: string, options: FrontendLogOptions): void => {
        // eslint-disable-next-line no-console
        console.info(`[${options.category}] ${message}`, formatPayload(options));
    },
    warn: (message: string, options: FrontendLogOptions): void => {
        // eslint-disable-next-line no-console
        console.warn(`[${options.category}] ${message}`, formatPayload(options));
    },
    error: (message: string, options: FrontendLogOptions): void => {
        recordError("logger", `[${options.category}] ${message}`, options.error instanceof Error ? options.error.stack : undefined);
        // eslint-disable-next-line no-console
        console.error(`[${options.category}] ${message}`, formatPayload(options));
    },
};
